import { type QueryKey } from 'react-query'

/**
 * Helper function for building query keys with optional parameters.
 *
 * Keys are arrays, and this function accepts an array of values to include
 * in the key. However, some of these values are optional. If an optional
 * value (undefined) is found, we stop building the key at that point.
 *
 * This lets us invalidate all queries that share the same prefix, even if
 * we don't have access to all the parameters that were used to build the full key.
 *
 * @param parts - Array of values to include in the query key
 * @returns A QueryKey array built from the provided parts up to the first undefined
 * value or the end of the array
 */
export const buildQueryKey = (parts: unknown[]): QueryKey => {
  const key: unknown[] = []

  for (const part of parts) {
    if (part === undefined) {
      break
    }
    key.push(part)
  }

  if (key.length === 0) {
    console.warn(
      'Warning: buildQueryKey was called and resulted in an empty query key. This may lead to undesirable behaviour in react-query. Ensure that at least one part of the key is defined.'
    )
  }

  return key
}
